// extracted by mini-css-extract-plugin
export default {"cet_social_list":"footer_cet_social_list__yTXep"};